<!-- Dropdown de contas -->
<!-- <div class="card mb-4" *ngIf="showConectAccount && !displayAguarde">
    <div class="col-12" *ngIf="showConectAccount && !displayAguarde">
        <div class="card cursor-pointer border-dashed border-1 surface-border flex flex-column justify-content-center align-items-center ss-g-hover-border2 text-center shadow-none"
            style="height:160px;" (click)="conectGoogle()">
            <img src="assets/youtube-color.svg" width="36" class="mb-3" />
            <span class="font-medium">Conectar conta do Youtube</span>
            <span class="text-sm text-500">Conecte uma conta do Google para começar</span>
        </div>
    </div>
</div> -->
<div class="card mb-4">
    <!-- Skeleton para evitar shift -->
    <div *ngIf="displayAguarde">
        <p-skeleton height="40px" width="100%"></p-skeleton>
        <div class="mb-2 mt-4"></div>
        <p-skeleton height="40px" width="100%"></p-skeleton>
        <div class="mb-2 mt-4"></div>
        <p-skeleton height="40px" width="100%"></p-skeleton>
        <div class="mb-2 mt-4"></div>
        <p-skeleton height="40px" width="100%"></p-skeleton>
    </div>


    <div *ngIf="!displayAguarde">
        <div class="flex align-items-center cursor-pointer" [class.mb-3]="!collapsed.ytMain" (click)="toggle('ytMain')"
            pRipple>
            <i class="bi bi-youtube mr-2" style="font-size: 2rem;color: red;"></i>
            <div>
                <div class="font-bold">Youtube</div>
                <div class="text-sm text-500">{{ getMainText() }}</div>
            </div>

            <!-- seta à direita -->
            <i class="pi pi-fw pi-angle-down ml-auto transition-transform"
                [ngClass]="{ 'rotate-180': !collapsed.ytMain }"></i>
        </div>

    </div>
    <div class="collapsible" [class.collapsed]="collapsed.ytMain" *ngIf="!displayAguarde">
        <div class="collapsible__inner">
            <!-- <div class="card mb-4" *ngIf="showConectAccount && !displayAguarde">
                <div class="col-12" *ngIf="showConectAccount && !displayAguarde"> -->
            <div class="" *ngIf="showConectAccount && !displayAguarde">
                <div class="" *ngIf="showConectAccount && !displayAguarde">
                    <div class="card cursor-pointer border-dashed border-1 surface-border flex flex-column justify-content-center align-items-center ss-g-hover-border2 text-center shadow-none"
                        style="height:160px;" (click)="conectGoogle()">
                        <img src="assets/youtube-color.svg" width="36" class="mb-3" />
                        <span class="font-medium">Conectar conta do Youtube</span>
                        <span class="text-sm text-500">Conecte uma conta do Google para começar</span>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="collapsible" [class.collapsed]="collapsed.ytMain" *ngIf="!showConectAccount && !displayAguarde">
        <div class="collapsible__inner">

            <div *ngIf="!showConectAccount && !displayAguarde">
                <div class="mb-2"></div>
                <p-dropdown *ngIf="!showConectAccount && !displayAguarde" [appendTo]="'body'" [options]="googleAccountsOptions"
                    [(ngModel)]="selectedGoogleAccountId" (onChange)="onSelectGoogleAccount($event.value)"
                    optionLabel="label" optionValue="value" placeholder="Selecione a conta Google">
                    <ng-template let-o pTemplate="item">
                        <div class="flex align-items-center">
                            <ng-container *ngIf="o.value !== 'add_account'; else addAccountItem">
                                <img [src]="o.picture" width="24" class="mr-2" />
                                <span>{{ o.label }}</span>
                                <small *ngIf="o.email" class="ml-2 text-xs text-500">({{ o.email }})</small>
                            </ng-container>
                            <ng-template #addAccountItem>
                                <i class="pi pi-plus mr-2"></i>
                                <span>{{ o.label }}</span>
                            </ng-template>
                        </div>
                    </ng-template>
                    <ng-template let-o pTemplate="selectedItem">
                        <div class="flex align-items-center">
                            <ng-container *ngIf="o.value !== 'add_account'; else addAccountSelected">
                                <img [src]="o.picture" width="24" class="mr-2" />
                                <span>{{ o.label }}</span>
                                <small *ngIf="o.email" class="ml-2 text-xs text-500">({{ o.email }})</small>
                            </ng-container>
                            <ng-template #addAccountSelected>
                                <i class="pi pi-plus mr-2"></i>
                                <span>{{ o.label }}</span>
                            </ng-template>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>


            <div class=" p-0 mb-4">
                <div class="mt-4 pt-0">
                    <!-- SKELETON ENQUANTO CARREGA -->
                    <p-skeleton width="100%" *ngIf="loadingChannels" height="40px" class="w-full mb-2"></p-skeleton>
                    <p-dropdown *ngIf="
                        youtubeChannelsOptions.length &&
                        !loadingChannels &&
                        activeTab.label !== 'Hashtag' &&
                        activeTab.label !== 'Canal' &&
                        (activeTab.label !== 'Playlist' || privatePlaylists)
                        " [appendTo]="'body'" [options]="youtubeChannelsOptions" [(ngModel)]="selectedChannelId"
                        (onChange)="onChannelChange($event.value)" optionLabel="label" optionValue="value"
                        placeholder="Selecione um canal YouTube">
                        <ng-template let-o pTemplate="item">
                            <div class="flex align-items-center">
                                <img *ngIf="o.picture" [src]="o.picture" width="24" class="mr-2" />
                                <span>{{ o.label }}</span>
                            </div>
                        </ng-template>
                        <ng-template let-o pTemplate="selectedItem">
                            <div class="flex align-items-center">
                                <img *ngIf="o.picture" [src]="o.picture" width="24" class="mr-2" />
                                <span>{{ o.label }}</span>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
            </div>

            <div class="flex align-items-center  mb-3" *ngIf="!showConectAccount && showAutoPublish && !displayAguarde">
                <p-inputSwitch [(ngModel)]="autoPublish" styleClass="mr-3"
                    (onChange)="onToggleAutoPublish($event.checked)"></p-inputSwitch>
                <div>
                    <div class="font-semibold text-lg">Auto-publicar</div>
                    <div class="text-sm text-500">Publicar mídias capturadas</div>
                </div>
            </div>

            <!-- Tabs -->
            <p-tabMenu [model]="tabs" [(activeItem)]="activeTab"
                *ngIf="!showConectAccount && !displayAguarde"></p-tabMenu>

            <!-- Descrição da aba ativa -->
            <div class="mt-2 text-sm text-500" *ngIf="!showConectAccount && !displayAguarde" [ngSwitch]="activeTab.label">
                <span *ngSwitchCase="'Hashtag'">Busque por vídeos contendo um hashtag (e.g.: #futebol).</span>
                <span *ngSwitchCase="'Canal'">Busque por vídeos de um @canal.</span>
                <span *ngSwitchCase="'Playlist'">Busque por vídeos de Playlists públicas de outros canais ou de seu próprio canal.</span>
                <span *ngSwitchCase="'Mídias'">Liste os vídeos de seu canal.</span>
                <span *ngSwitchCase="'Curtidos'">Liste os vídeos curtidos por sua conta.</span>
            </div>

            <!-- Abas: Mídias, Hashtag, Canal -->
            <!-- FILTRAR POR TIPO (fixo, sempre visível) -->
            <div class="p-fluid grid mb-2" *ngIf="!showConectAccount && !displayAguarde">
                <div class="col-12 mt-4">
                    <label class="ss-g-globalClassLabel mb-1">Filtrar por tipo</label>
                    <div class="mb-2"></div>
                    <p-multiSelect class="w-full" [appendTo]="'body'" [options]="mediaTypeOptions" [(ngModel)]="getActiveMediaTypesModel"
                        defaultLabel="Todos">
                    </p-multiSelect>
                </div>
                <!-- 🔎 Filtro por texto na descrição -->
                <!-- <div class="col-12">
                    <label class="ss-g-globalClassLabel ">Filtrar por descrição</label>
                    <div class="mb-2"></div>
                    <div class="p-inputgroup">
                        <input pInputText class="w-full" type="text" [(ngModel)]="descriptionFilter"
                            (ngModelChange)="onFiltersChanged()" placeholder="Ex.: review, receita, shorts..." />
                        <button *ngIf="descriptionFilter" pButton type="button" icon="pi pi-times"
                            (click)="clearDescriptionFilter()" class="p-button-text"
                            aria-label="Limpar filtro"></button>
                    </div>
                </div> -->
            </div>

            <!-- Conteúdo das Abas -->
            <div class="tab-content mt-3" *ngIf="!showConectAccount && !displayAguarde">
                <!-- ABA "Hashtag" -->
                <div *ngIf="activeTab.label === 'Hashtag'">
                    <div class="mb-3">
                        <label for="hashtag" class="ss-g-globalClassLabel">Hashtag (sem #)</label>
                        <div class="p-inputgroup mt-2 w-full">
                            <span class="p-inputgroup-addon">#</span>
                            <input id="hashtag" pInputText class="w-full" [(ngModel)]="hashtag" placeholder="ex: sunset"
                                (ngModelChange)="onHashtagChange($event)" />
                        </div>
                    </div>


                    <button *ngIf="showContent" pButton type="button" class="w-full mt-2"
                        [disabled]="!hashtag || LoadSearching" (click)="loadHashtagMedia(true)">
                        <ng-container *ngIf="LoadSearching; else searchIcon">
                            <i class="pi pi-spinner pi-spin mr-2"></i>
                        </ng-container>
                        <ng-template #searchIcon>
                            <i class="pi pi-search mr-2"></i>
                        </ng-template>
                        <span style="flex: 1 1 0; text-align: center; " class="p-button-label">Buscar</span>
                    </button>
                </div>

                <!-- ABA "Mídias" -->
                <div *ngIf="activeTab.label === 'Mídias'">
                    <button *ngIf="showContent" pButton type="button" class="w-full mt-2"
                        [disabled]="!selectedChannelId || !hasChannels" (click)="loadUserMedia(true)">
                        <ng-container *ngIf="LoadSearching; else searchIconUser">
                            <i class="pi pi-spinner pi-spin mr-2"></i>
                        </ng-container>
                        <ng-template #searchIconUser>
                            <i class="pi pi-search mr-2"></i>
                        </ng-template>
                        <span style="flex: 1 1 0; text-align: center;" class="p-button-label">Buscar</span>
                    </button>
                </div>

                <!-- ABA "Canal" -->
                <div *ngIf="activeTab.label === 'Canal'">
                    <div class="mb-3">
                        <label for="targetChannel" class="ss-g-globalClassLabel">Nome ou ID do Canal</label>
                        <div class="p-inputgroup mt-2 w-full">
                            <span class="p-inputgroup-addon">@</span>
                            <input id="targetChannel" pInputText class="w-full" [(ngModel)]="targetChannel"
                                placeholder="Digite o nome ou ID do canal"
                                (ngModelChange)="onTargetChannelChange($event)" />
                        </div>
                    </div>
                    <button *ngIf="showContent" pButton type="button" class="w-full mt-2" [disabled]="!targetChannel"
                        (click)="loadChannelMedia(true)">
                        <ng-container *ngIf="loadingSearch; else searchIconChannel">
                            <i class="pi pi-spinner pi-spin mr-2"></i>
                        </ng-container>
                        <ng-template #searchIconChannel>
                            <i class="pi pi-search mr-2"></i>
                        </ng-template>
                        <span style="flex: 1 1 0; text-align: center;" class="p-button-label">Buscar</span>
                    </button>
                </div>

                <!-- Curtidos -->
                <div *ngIf="activeTab.label === 'Curtidos'">
                    <button *ngIf="showContent" pButton type="button" class="w-full mt-2"
                        [disabled]="!selectedChannelId" (click)="loadLikedMedia(true)">
                        <ng-container *ngIf="LoadSearching; else searchIconLiked">
                            <i class="pi pi-spinner pi-spin mr-2"></i>
                        </ng-container>
                        <ng-template #searchIconLiked>
                            <i class="pi pi-search mr-2"></i>
                        </ng-template>
                        <span style="flex: 1 1 0; text-align: center;" class="p-button-label">Buscar</span>
                    </button>
                </div>


                <div *ngIf="activeTab.label === 'Playlist'">
                    <!-- Switch: privadas -->
                    <div class="flex align-items-center mb-3">
                        <p-inputSwitch [(ngModel)]="privatePlaylists" (onChange)="onPrivateToggle($event.checked)"
                            class="mr-2 ml-1"></p-inputSwitch>
                        <div>
                            <div class="font-semibold">Playlists privadas</div>
                            <div class="text-sm text-500">Usar playlists da conta conectada (inclui privadas)</div>
                        </div>
                    </div>

                    <!-- Playlist -->
                    <div class="mb-3" *ngIf="!privatePlaylists">
                        <label for="targetChannel" class="ss-g-globalClassLabel">Nome ou ID do Canal</label>
                        <div class="p-inputgroup mt-2 w-full">
                            <span class="p-inputgroup-addon">@</span>
                            <input id="targetChannel" pInputText class="w-full" [(ngModel)]="targetChannel"
                                placeholder="Digite o nome ou ID do canal" />
                        </div>
                    </div>

                    <!-- Buscar playlists -->
                    <!-- Botão de listar playlists: muda rótulo/validação conforme modo -->
                    <button pButton type="button" class="w-full mt-2"
                        [disabled]="privatePlaylists ? (!selectedGoogleAccountId || !selectedChannelId) : (!targetChannel || !selectedGoogleAccountId)"
                        (click)="loadChannelPlaylistsForSelect(true)">
                        <ng-container *ngIf="loadingPlaylists; else iconTpl">
                            <i class="pi pi-spinner pi-spin mr-2"></i>
                        </ng-container>
                        <ng-template #iconTpl>
                            <i class="pi" [ngClass]="privatePlaylists ? 'pi-lock' : 'pi-list'"></i>
                            <span class="mr-2"></span>
                        </ng-template>
                        <span class="p-button-label" style="flex:1 1 0;text-align:center">
                            {{ privatePlaylists ? 'Listar minhas playlists' : 'Listar Playlists' }}
                        </span>
                    </button>

                    <!-- MultiSelect de playlists -->
                    <div class="mt-3" *ngIf="playlistsOptions?.length">
                        <label class="ss-g-globalClassLabel mb-2 block">Selecione playlists</label>
                        <p-dropdown [options]="playlistsOptions" [(ngModel)]="selectedPlaylist" optionLabel="label"
                            optionValue="value" [filter]="true" [virtualScroll]="true" [virtualScrollItemSize]="38"
                            [appendTo]="'body'" (onChange)="onPlaylistsChange($event)" [showClear]="true"
                            placeholder="Selecione uma playlist">
                            <ng-template let-opt pTemplate="item">
                                <div class="flex align-items-center gap-2">
                                    <img *ngIf="opt.thumbnail" [src]="opt.thumbnail" width="36" height="20"
                                        class="border-round" />
                                    <div class="flex flex-column">
                                        <span class="font-medium">{{ opt.label }}</span>
                                        <small class="text-600" *ngIf="opt.itemCount !== null">{{ opt.itemCount }}
                                            vídeos</small>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="selectedItem" let-sel>
                                <div class="flex align-items-center gap-2">
                                    <i class="pi pi-list"></i>
                                    <span class="line-clamp-1">{{ sel.label }}</span>
                                </div>
                            </ng-template>
                        </p-dropdown>

                    </div>
                </div>

            </div>

        </div>
    </div>

</div>

<div class="card mb-4" *ngIf="!isFeed && !displayAguarde && feedTmp">
    <div *ngIf="!displayAguarde">
        <div class="flex align-items-center cursor-pointer" [class.mb-3]="!collapsed.ytExtract"
            (click)="toggle('ytExtract')" pRipple>
            <i class="bi bi-youtube mr-2" style="font-size: 2rem;color: red;"></i>
            <div>
                <div class="font-bold">Youtube</div>
                <div class="text-sm text-500">Importar via URL (mídia deve ser PÚBLICA)</div>
            </div>

            <!-- seta à direita -->
            <i class="pi pi-fw pi-angle-down ml-auto transition-transform"
                [ngClass]="{ 'rotate-180': !collapsed.ytExtract }"></i>
        </div>
    </div>
    <div *ngIf="!displayAguarde">
        <div class="collapsible" [class.collapsed]="collapsed.ytExtract">
            <div class="collapsible__inner">

                <div *ngIf="!displayAguarde">
                    <div class="mb-2"></div>

                    <div class="p-inputgroup mt-2 w-full">
                        <span class="p-inputgroup-addon"><i class="pi pi-link"></i></span>
                        <input pInputText class="w-full" [(ngModel)]="youtubeUrl" placeholder="Cole a URL do YouTube"
                            (ngModelChange)="checkYoutubeUrl()" />
                    </div>
                    <div class="flex justify-between items-center mt-1 text-sm">
                        <small class="p-error mr-2 w-full"
                            [ngStyle]="{ visibility: youtubeInvalid ? 'visible' : 'hidden' }">
                            URL do YouTube inválida!
                        </small>
                    </div>

                    <button *ngIf="showContent" pButton type="button" class="w-full mt-4"
                        [disabled]="!youtubeUrl || extracting || youtubeInvalid" (click)="extract(true)">
                        <ng-container *ngIf="extracting; else downlodIcon">
                            <i class="pi pi-spinner pi-spin mr-2"></i>
                        </ng-container>
                        <ng-template #downlodIcon>
                            <i class="pi pi-download  mr-2"></i>
                        </ng-template>
                        <span style="flex: 1 1 0; text-align: center; " class="p-button-label">Extrair</span>
                    </button>

                </div>
            </div>
        </div>


    </div>
</div>

<!-- GRID DE MÍDIAS -->
<div *ngIf="showDta" class="mt-4">
    <p-dataView *ngIf="showContent" [value]="media" layout="grid" [rows]="20">
        <ng-template pTemplate="gridItem" let-item>

            <div class="col-12 sm:col-6 md:col-6 lg:col-6">
                <div class="dv-item relative">
                    <!-- Checkbox -->
                    <div class="absolute left-1 top-1 z-2">
                        <p-checkbox [binary]="true" [ngModel]="isSelected(item)"
                            (onChange)="toggleSelection(item)"></p-checkbox>
                    </div>
                    <div class="card m-0 p-0 border-round shadow-none s-s-l-minH">
                        <div class="w-full border-round-top overflow-hidden" style="text-align: center;">
                            <!-- Player YouTube responsivo -->
                            <div *ngIf="item.safe_player_url; else showImage" class="youtube-player w-full">
                                <iframe [src]="item.safe_player_url" frameborder="0" width="100%" height="230"
                                    allow="autoplay; encrypted-media" allowfullscreen>
                                </iframe>
                            </div>
                            <ng-template #showImage>
                                <img *ngIf="item.thumbnail" [src]="item.thumbnail" class="w-full h-60 object-cover" />
                            </ng-template>
                        </div>
                        <div class="p-3">
                            <div class="text-700 text-sm mb-2 white-space-pre-line breakable"
                                style="-webkit-box-orient: vertical; -webkit-line-clamp: 1; display: -webkit-box; overflow: hidden;">
                                {{ item.title }}
                            </div>
                            <span *ngIf="!extractedByUrl">
                                … <a href="#" (click)="openDialog(item); $event.preventDefault()">ver mais</a>
                            </span>
                            <div class="text-xs text-500 mt-2">
                                {{ item.publishedAt | date:'dd MMM yyyy' }}
                            </div>
                            <a [href]="item.link" target="_blank" class="text-primary text-sm mt-1 block">
                                Ver no YouTube
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </ng-template>
        <ng-template pTemplate="empty">
            <div class="text-center text-600 mt-4">Nenhum vídeo encontrado.</div>
        </ng-template>
    </p-dataView>

</div>
<button *ngIf="hasMoreMedia && showContent && !extractedByUrl" pButton type="button" label="Carregar mais"
    (click)="loadMoreMedia()" class="mt-2 load-more-btn w-full"></button>

<p-toast></p-toast>
<app-dialog-aguarde [visible]="displayAguarde" [baseZIndex]="16000"></app-dialog-aguarde>